import { render, staticRenderFns } from "./manage-exclusion.html?vue&type=template&id=0bef1640&scoped=true&external"
import script from "./manage-exclusion.js?vue&type=script&lang=js&external"
export * from "./manage-exclusion.js?vue&type=script&lang=js&external"
import style0 from "./manage-exclusion.scss?vue&type=style&index=0&id=0bef1640&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bef1640",
  null
  
)

export default component.exports